<cipo-dialog-header [title]="label()" testId="cipo-address-dialog-title" closeTestId="cipo-address-dialog-close" />
<mat-dialog-content class="address-dialog-content">
    <div fxLayout fxLayoutGap="8px" class="cipo--height--full">
        @let editModeMap = editMode() && (!multiple() || (multiple() && addresses().length > 0));
        @if (multiple() || editMode()) {
            <div fxFlex="250px" fxLayout="column" class="cipo--height--full">
                @if (multiple()) {
                    @if (editMode()) {
                        <div fxFlex="74px">
                            <button
                                mat-raised-button
                                color="primary"
                                data-testid="cipo-address-dialog-add-address"
                                [disabled]="addresses().length > 0 && !currentAddressIsValid()"
                                (click)="addAddress()">
                                <mat-icon aria-hidden="true">add</mat-icon>
                                {{ "actions.addNew" | translate }}
                            </button>
                        </div>
                    }
                    <div fxFlex class="cipo--overflow--auto">
                        <mat-list role="list" data-testid="cipo-address-dialog-address-list">
                            @for (address of addresses(); track $index) {
                                @if ($index > 0) {
                                    <mat-divider></mat-divider>
                                }
                                <mat-list-item
                                    role="listitem"
                                    class="selectable cipo--height--auto-important p-a-xs"
                                    data-testid="cipo-address-dialog-address-list-item"
                                    [class.selected]="$index === addressIndex()"
                                    [class.invalid]="editMode() && !addressService.addressIsValid(address)"
                                    [class.disabled]="
                                        editMode() && $index !== addressIndex() && !currentAddressIsValid()
                                    "
                                    (click)="setAddress($index)">
                                    <div fxLayout fxLayoutGap="8px" fxLayoutAlign="start center" class="address">
                                        <div
                                            fxFlex="none"
                                            [innerHTML]="
                                                azureMapService.createPinElement(
                                                    $index,
                                                    $index === addressIndex(),
                                                    multiple()
                                                )
                                            "></div>
                                        <div fxFlex>
                                            @if (address && address.address && address.lat && address.lon) {
                                                <div class="cipo-text--medium-sm">
                                                    {{ addressService.formatAddress(address, displayType()) }}
                                                </div>
                                                <div class="cipo-text--label">
                                                    {{ addressService.formatPosition(address) }}
                                                    @if (address.isGlobal) {
                                                        <span class="global-tag">
                                                            {{ "MODULE_DEF_ADDRESS.GLOBAL_TAG" | translate }}
                                                        </span>
                                                    }
                                                </div>
                                            } @else {
                                                <div class="cipo-text--label">
                                                    {{ "MODULE_DEF_ADDRESS.NO_ADDRESS" | translate }}
                                                </div>
                                            }
                                        </div>
                                        @if (
                                            multiple() &&
                                            editMode() &&
                                            canCreateGlobalAddress() &&
                                            !address.isGlobal &&
                                            addressService.addressIsValid(address) &&
                                            ($index === addressIndex() || currentAddressIsValid())
                                        ) {
                                            <button
                                                fxFlex="none"
                                                mat-icon-button
                                                class="cipo--display--none promote-action"
                                                data-testid="cipo-address-dialog-promote-global"
                                                [matTooltip]="'MODULE_DEF_ADDRESS.PROMOTE_GLOBAL_TOOLTIP' | translate"
                                                [attr.aria-label]="
                                                    'MODULE_DEF_ADDRESS.PROMOTE_GLOBAL_TOOLTIP' | translate
                                                "
                                                (click)="$event.stopPropagation(); promoteToGlobal($index)">
                                                <mat-icon class="m-t-xs" aria-hidden="true">public</mat-icon>
                                            </button>
                                        }
                                        @if (
                                            multiple() &&
                                            editMode() &&
                                            ($index === addressIndex() || currentAddressIsValid())
                                        ) {
                                            <button
                                                fxFlex="none"
                                                mat-icon-button
                                                class="cipo--display--none delete-action"
                                                data-testid="cipo-address-dialog-delete-address"
                                                [attr.aria-label]="'a11y.common.delete' | translate"
                                                (click)="$event.stopPropagation(); deleteAddress($index)">
                                                <mat-icon class="m-t-xs" aria-hidden="true">delete</mat-icon>
                                            </button>
                                        }
                                    </div>
                                </mat-list-item>
                            }
                            @if (addresses().length === 0) {
                                <cipo-not-found />
                            }
                        </mat-list>
                    </div>
                    @if (editMode()) {
                        <mat-divider></mat-divider>
                    }
                }
                @if (editMode()) {
                    <div
                        fxFlex="none"
                        fxLayout
                        fxLayoutAlign="space-between center"
                        [fxFlexOffset]="!multiple() ? '74px' : '0'"
                        class="p-a-xs">
                        <h5>{{ "MODULE_DEF_ADDRESS.GLOBAL_ADDRESSES" | translate }}</h5>
                        @if (canUpdateGlobalAddresses() || canCreateGlobalAddress() || canDeleteGlobalAddress()) {
                            <button
                                mat-icon-button
                                data-testid="cipo-address-dialog-manage-global"
                                [matTooltip]="'MODULE_DEF_ADDRESS.MANAGE_GLOBAL_TOOLTIP' | translate"
                                [attr.aria-label]="'MODULE_DEF_ADDRESS.MANAGE_GLOBAL_TOOLTIP' | translate"
                                (click)="openGlobalAddressesDialog()">
                                <mat-icon aria-hidden="true">edit</mat-icon>
                            </button>
                        }
                    </div>
                    <mat-form-field class="cipo--width--full p-x-xs" appearance="outline">
                        <mat-icon matPrefix>search</mat-icon>
                        <input
                            matInput
                            [ngModel]="globalSearchTerm()"
                            (ngModelChange)="globalSearchTerm.set($event)"
                            [placeholder]="'MODULE_DEF_ADDRESS.SEARCH_GLOBAL_PLACEHOLDER' | translate"
                            data-testid="cipo-address-dialog-global-search" />
                        @if (globalSearchTerm()) {
                            <button
                                matSuffix
                                mat-icon-button
                                (click)="globalSearchTerm.set('')"
                                [attr.aria-label]="'a11y.form.clearInput' | translate">
                                <mat-icon aria-hidden="true">close</mat-icon>
                            </button>
                        }
                    </mat-form-field>
                    <div fxFlex class="cipo--overflow--auto">
                        <mat-list role="list" data-testid="cipo-address-dialog-global-address-list">
                            @for (globalAddress of filteredGlobalAddresses(); track globalAddress.locationId) {
                                @if (!$first) {
                                    <mat-divider></mat-divider>
                                }
                                <mat-list-item
                                    role="listitem"
                                    class="cipo--height--auto-important p-a-xs"
                                    data-testid="cipo-address-dialog-global-address-list-item">
                                    <div fxLayout fxLayoutGap="8px" fxLayoutAlign="start center" class="address">
                                        <div fxFlex>
                                            <div class="cipo-text--medium-sm">
                                                {{ addressService.formatAddress(globalAddress, undefined) }}
                                            </div>
                                            <div class="cipo-text--label">
                                                {{ addressService.formatPosition(globalAddress) }}
                                            </div>
                                        </div>
                                        <button
                                            fxFlex="none"
                                            mat-icon-button
                                            class="pick-action"
                                            data-testid="cipo-address-dialog-pick-global"
                                            [matTooltip]="'MODULE_DEF_ADDRESS.PICK_GLOBAL_TOOLTIP' | translate"
                                            [attr.aria-label]="'MODULE_DEF_ADDRESS.PICK_GLOBAL_TOOLTIP' | translate"
                                            (click)="$event.stopPropagation(); selectGlobalAddress(globalAddress)">
                                            <mat-icon class="m-t-xs" aria-hidden="true">add_circle</mat-icon>
                                        </button>
                                        @if (canDeleteGlobalAddress()) {
                                            <button
                                                fxFlex="none"
                                                mat-icon-button
                                                class="cipo--display--none delete-action"
                                                data-testid="cipo-address-dialog-delete-global"
                                                [matTooltip]="'MODULE_DEF_ADDRESS.DELETE_GLOBAL_TOOLTIP' | translate"
                                                [attr.aria-label]="
                                                    'MODULE_DEF_ADDRESS.DELETE_GLOBAL_TOOLTIP' | translate
                                                "
                                                (click)="$event.stopPropagation(); deleteGlobalAddress(globalAddress)">
                                                <mat-icon class="m-t-xs" aria-hidden="true">delete</mat-icon>
                                            </button>
                                        }
                                    </div>
                                </mat-list-item>
                            }
                            @if (filteredGlobalAddresses().length === 0) {
                                <cipo-not-found />
                            }
                        </mat-list>
                    </div>
                }
            </div>
        }
        <div fxFlex fxLayout="column" class="cipo--height--full">
            @if (addresses().length > 0 || !multiple()) {
                <cipo-address-form
                    [fxFlex]="editMode() ? '74px' : 'none'"
                    [editMode]="editMode()"
                    [multiple]="multiple()"
                    [index]="addressIndex()"
                    [address]="address()"
                    [displayType]="displayType()"
                    (addressChange)="addressChanged($event)"></cipo-address-form>
            }
            <cipo-azure-map
                fxFlex
                [editMode]="editModeMap"
                [multiple]="multiple()"
                [coordinates]="coordinates()"
                (coordinatesChange)="handleCoordinatesChanged($event)"
                [(selected)]="addressIndex"></cipo-azure-map>
        </div>
    </div>
</mat-dialog-content>
@if (editMode()) {
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close data-testid="cipo-address-dialog-action-close">
            {{ "general.close" | translate }}
        </button>
        <button
            mat-flat-button
            color="primary"
            data-testid="cipo-address-dialog-action-save"
            [disabled]="!canSave()"
            (click)="save()">
            {{ "general.save" | translate }}
        </button>
    </mat-dialog-actions>
}
